(function () {
  var scrollThreshold = 82;
  var el = document.querySelector('.facets-vertical');
  var wrapper = el && el.querySelector('.facets-wrapper');
  if (!el || !wrapper) return;

  function update() {
    el.classList.toggle('facets-scrolled-past', window.scrollY >= scrollThreshold);
  }

  var ticking = false;
  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      }
    },
    { passive: true },
  );

  update();
})();
